import {
  addCustomer,
  deleteCustomer,
  getCustomers,
  updateCustomer,
} from "../actions/customer.action";
import TableList from "../components/TableList";
import { Customer } from "../models/customer.model";
import { useRef } from "react";
import CustomerForm from "./CustomerForm";
import { filterOnKeys } from "../lib/helper";
import { FilterGroup, FilterType } from "../components/TableFilter";
import { FormRefEvent, HeadCell } from "../models/base.model";

const headCells: readonly HeadCell[] = [
  {
    id: "name",
    label: "Name",
  },
  {
    id: "email",
    label: "Email",
  },
];

const filters: FilterGroup<Customer>[] = [
  {
    title: "Filter By Date",
    items: [
      {
        name: "createdAt",
        type: FilterType.date_range,
      },
      {
        name: "updatedAt",
        type: FilterType.date_range,
      },
    ],
  },
];

export default function Customers() {
  const formRef = useRef<FormRefEvent<Customer>>(null);

  const onAddOrUpdate = (param?: Customer) => {
    return window.webApp.setTab<Customer>({
      title: `${param ? "Update" : "New"} Customer`,
      element: <CustomerForm ref={formRef} defaultValues={param} />,
      onOk: async () => {
        if (!formRef.current) {
          throw new Error("Form creation error, please refresh or contact us!");
        }
        const value = await formRef.current.onSubmit();
        const res = param
          ? await updateCustomer({ ...param, ...value })
          : await addCustomer(value);
        return res;
      },
      show: true,
    });
  };

  const onDelete = (param: Customer) => {
    return deleteCustomer(param.id);
  };

  const onSearch = async (value: string, original: Customer[]) => {
    if (original) {
      return {
        data: original.filter((a) => filterOnKeys(a, ["name", "email"], value)),
      };
    } else {
      return { data: [] };
    }
  };

  return (
    <TableList<Customer>
      headCells={headCells}
      onAddBtnText="New Customer"
      uid="id"
      onAdd={onAddOrUpdate}
      onSearch={onSearch}
      searchText="Search by name, email"
      onEdit={onAddOrUpdate}
      onDelete={onDelete}
      onLoad={getCustomers}
      filters={filters}
    />
  );
}
